import PropTypes from 'prop-types';
import {
  Group,
  Text,
} from '@mantine/core';
import {
  isArray,
} from '@/helpers/is';
import { getItemValue } from '@/helpers/string';
import Transforms from '@/components/Transforms';
import DataAddOn from '@/components/DataAddOn';
import ColumnActions from '../ColumnActions';

const ColumnContent = (props) => {
  const {
    accessor,
    item = {}, // table row
    actions = [],
    transforms = [],
    type,
    menuLabel,
  } = props;

  const data = getItemValue(item, accessor);
  let content = null;

  if (isArray(actions) && actions.length) {
    content = <ColumnActions items={actions} row={item} menuLabel={menuLabel} />;
  } else {
    content = <Group gap="xs" wrap="nowrap">
      {
        (isArray(data) && data.length)
          ? <Text component="span">
            <Transforms source={data[0]} transforms={transforms} row={item} />
          </Text>
          : <Transforms source={data} transforms={transforms} row={item} />
      }
      <DataAddOn type={type} data={data} />
    </Group>;
  }

  return content;
};

ColumnContent.propTypes = {
  accessor: PropTypes.string,
  item: PropTypes.object,
  actions: PropTypes.array,
  transforms: PropTypes.array,
  menuLabel: PropTypes.string,
};

export default ColumnContent;
